/**
 * Theme Storage Utility
 * 
 * Manages localStorage for theme and logo customization
 * Works in both demo and production modes for caching
 */

const THEME_STORAGE_KEY = 'wedding_theme_config';
const LOGO_STORAGE_KEY = 'wedding_logo_config';

// Default values
export const DEFAULT_THEME = {
  primary: '#8EA58C',
  secondary: '#5C4033',
  accent: '#BFCFBB',
  neutral: '#D9C2A8',
  surface: '#ffffff',
};

export const DEFAULT_FONT = '-apple-system, BlinkMacSystemFont, \'Segoe UI\', \'Roboto\', \'Oxygen\', \'Ubuntu\', \'Cantarell\', \'Fira Sans\', \'Droid Sans\', \'Helvetica Neue\', sans-serif';

export const DEFAULT_LOGO = '/UserData/Logo.svg';
export const DEFAULT_TEXT = 'Wedding of Groom & Bride';

// Theme storage
export const saveTheme = (colors, font = null) => {
  try {
    const themeData = { colors, font: font || DEFAULT_FONT };
    localStorage.setItem(THEME_STORAGE_KEY, JSON.stringify(themeData));
  } catch (e) {
    console.error('Failed to save theme:', e);
  }
};

export const loadTheme = () => {
  try {
    const saved = localStorage.getItem(THEME_STORAGE_KEY);
    if (!saved) {
      return { colors: DEFAULT_THEME, font: DEFAULT_FONT };
    }
    const parsed = JSON.parse(saved);
    // Handle old format (just colors) and new format (colors + font)
    if (parsed.colors) {
      return { colors: parsed.colors, font: parsed.font || DEFAULT_FONT };
    }
    // Old format - just colors
    return { colors: parsed, font: DEFAULT_FONT };
  } catch (e) {
    console.error('Failed to load theme:', e);
    return { colors: DEFAULT_THEME, font: DEFAULT_FONT };
  }
};

// Logo storage
export const saveLogo = (logo, text) => {
  try {
    localStorage.setItem(LOGO_STORAGE_KEY, JSON.stringify({ logo, text }));
  } catch (e) {
    console.error('Failed to save logo:', e);
  }
};

export const loadLogo = () => {
  try {
    const saved = localStorage.getItem(LOGO_STORAGE_KEY);
    return saved ? JSON.parse(saved) : { logo: DEFAULT_LOGO, text: DEFAULT_TEXT };
  } catch (e) {
    console.error('Failed to load logo:', e);
    return { logo: DEFAULT_LOGO, text: DEFAULT_TEXT };
  }
};

// Tabs storage
const TABS_STORAGE_KEY = 'wedding_tabs_config';
export const DEFAULT_FLOORPLAN = '/UserData/floorplan.png';

export const saveTabs = (floorplan, showVenueTab = true, showMediaFilter = true, showGuestbookTab = true, showQAndATab = true, menu = null) => {
  try {
    localStorage.setItem(TABS_STORAGE_KEY, JSON.stringify({ floorplan, showVenueTab, showMediaFilter, showGuestbookTab, showQAndATab, menu }));
  } catch (e) {
    console.error('Failed to save tabs config:', e);
  }
};

export const loadTabs = () => {
  try {
    const saved = localStorage.getItem(TABS_STORAGE_KEY);
    const defaults = { floorplan: DEFAULT_FLOORPLAN, showVenueTab: true, showMediaFilter: true, showGuestbookTab: true, showQAndATab: true, menu: null };
    return saved ? { ...defaults, ...JSON.parse(saved) } : defaults;
  } catch (e) {
    console.error('Failed to load tabs config:', e);
    return { floorplan: DEFAULT_FLOORPLAN, showVenueTab: true, showMediaFilter: true, showGuestbookTab: true, showQAndATab: true, menu: null };
  }
};
